import { render, staticRenderFns } from "./cardAppeal.vue?vue&type=template&id=0301f085&"
import script from "./cardAppeal.vue?vue&type=script&lang=js&"
export * from "./cardAppeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports